(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["winter-wellness-hub"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){var b=e.target.closest('[data-result]');if(!b)return;var root=b.closest('.ww__quiz');if(!root)return;root.querySelectorAll('[data-panel]').forEach(function(p){p.classList.remove('is-active')});root.querySelectorAll('[data-result]').forEach(function(x){x.setAttribute('aria-pressed','false')});b.setAttribute('aria-pressed','true');var panel=root.querySelector('[data-panel="'+b.dataset.result+'"]');if(panel){panel.classList.add('is-active');panel.scrollIntoView({behavior:'smooth',block:'nearest'})}});

  } catch(e) { console.error(e); }
})();
})();
